module.exports = __webpack_public_path__ + "static/media/benefit.311c4d9e.png";